<template>
<div class="container main">
    <div class="row">
        <div class="offset-10 col-2 head-buttons-block">
            <router-link :to="{ name: 'auth'}" class="login-btn">
                <div class="enter-logo"></div><span>Войти</span>
            </router-link>
        </div>
        <div class="col-md-12">
            <div v-bind:class="{'msg-general-to-centre':!isRegistrationForm}">
                <div class="loader" v-if="loader_block">
                    <loader-component />
                </div>
                <div class="offset-md-3 col-md-6">
                    <msg-component :type_msg="msg_general.type" :text="msg_general.text"></msg-component>
                </div>
            </div>
            <div class="login_form registrarion" v-if="registrarion_form">
                <form autocomplete="off">
                    <div class="col-md-12">
                        <input class="mail" v-bind:class="{fail: msg_email.error}" v-model="email"
            v-on:keyup.enter="$refs.password.focus()"
            placeholder="Электронная почта" type="text">
            </div>
                        <div class="offset-md-3 col-md-6 after-input-msg">
                            <p v-if="msg_email.text">{{msg_email.text}}</p>
                        </div>
                        <div class="col-md-12">
                            <input class="pwd" v-bind:class="{fail: msg_password.error}" v-model="password"
              v-on:keyup.enter="$refs.password_confirmation.focus()"
              ref="password"
              placeholder="Пароль" type="password">
            </div>
                            <div class="offset-md-3 col-md-6 after-input-msg">
                                <p v-if="msg_password.text">{{msg_password.text}}</p>
                            </div>
                            <div class="col-md-12">
                                <input class="pwd" v-bind:class="{fail: msg_password_confirmation.error}"
                v-on:keyup.enter="$refs.name.focus()"
                ref="password_confirmation"
                v-model="password_confirmation"
                placeholder="Повторить пароль" type="password">
            </div>
                                <div class="offset-md-3 col-md-6 after-input-msg">
                                    <p v-if="msg_password_confirmation.text">{{msg_password_confirmation.text}}</p>
                                </div>
                                <div class="col-md-12">
                                    <input class="name" v-bind:class="{fail: msg_name.error}" v-model="name"
                  v-on:keyup.enter="saveUser"
                  ref="name"
                  placeholder="Ваше имя (желательно)" type="text">
            </div>
                                    <div class="offset-md-3 col-md-6 after-input-msg">
                                        <p v-if="msg_name.text">{{msg_name.text}}</p>
                                    </div>
                                    <div class="row">
                                        <div class="offset-3 col-1"><input id="rules-checkbox" class="rules-checkbox" v-model="rules" type="checkbox">
                                            <label class="system-actions" for="rules-checkbox">.</label>
                                        </div>
                                        <div class="col-4">
                                            <p class="text-for-rules-modal-link">Я соглашаюсь с <a v-b-modal.modallg class="rules-modal-link">правилами компании</a></p>
                                        </div>
                                    </div>
                                    <div class="offset-md-3 col-md-6 after-input-msg">
                                        <p v-if="msg_rules.text">{{msg_rules.text}}</p>
                                    </div>
                </form>
                <div class="col-md-12">
                    <button class="enter" @click="saveUser">Зарегистрироваться</button>
                </div>
            </div>
        </div>
    </div>
    <b-modal id="modallg" size="lg" title="" :hide-footer="true">
        <component :is="getRules && {template:getRules}" />
    </b-modal>
</div>
</template>

<script>
import msg from './elements/msg.vue'
import axios from 'axios'
import config from '@/config.js'
import loader from './elements/loader.vue'

export default {
    beforeCreate() {
        updateRules(this)
    },
    data() {
        return {
            msg_general: {
                type: 'hidden',
                text: ''
            },
            email: '',
            msg_email: {
                type: 'hidden',
                text: '',
                error: false
            },
            password: '',
            msg_password: {
                type: 'hidden',
                text: '',
                error: false
            },
            password_confirmation: '',
            msg_password_confirmation: {
                type: 'hidden',
                msg_text: '',
                error: false
            },
            name: '',
            msg_name: {
                type: 'hidden',
                text: '',
                error: false
            },
            rules_text: '',
            rules: false,
            msg_rules: {
                type: 'hidden',
                text: '',
                error: false
            },
            loader_block: false,
            registrarion_form: true
        }
    },
    components: {
        'msg-component': msg,
        'loader-component': loader
    },
    methods: {
        saveUser: function () {
            var vue_obj = this
            vue_obj.loader_block = true
            vue_obj.registrarion_form = false
            vue_obj.msg_general.type = 'hidden'
            vue_obj.msg_email.type = 'hidden'
            vue_obj.msg_password.type = 'hidden'
            vue_obj.msg_password_confirmation.type = 'hidden'
            vue_obj.msg_rules.type = 'hidden'
            vue_obj.msg_name.type = 'hidden'

            vue_obj.msg_email.error = false
            vue_obj.msg_password.error = false
            vue_obj.msg_password_confirmation.error = false
            vue_obj.msg_rules.error = false
            vue_obj.msg_name.error = false

            vue_obj.msg_email.text = ''
            vue_obj.msg_password.text = ''
            vue_obj.msg_password_confirmation.text = ''
            vue_obj.msg_rules.text = ''
            vue_obj.msg_name.text = ''

            var post_data = new FormData()
            post_data.set('name', this.name)
            post_data.set('email', this.email)
            post_data.set('password', this.password)
            post_data.set('password_confirmation', this.password_confirmation)
            post_data.set('rules', this.rules)

            axios({
                    method: 'POST',
                    url: config.API_HOST + '/registration/registrate',
                    data: post_data
                })
                .then(function (response) {
                    if (!!response.data.text) {
                        vue_obj.msg_general.type = 'success'
                        vue_obj.msg_general.text = response.data.text
                    }
                    vue_obj.loader_block = false
                })
                .catch(function (error) {
                    vue_obj.loader_block = false
                    vue_obj.registrarion_form = true
                    console.log(error.response.data)
                    if (!!error.response.data.exceptions) {
                        if (error.response.data.exceptions > 0) {
                            vue_obj.msg_general.type = 'alert'
                            vue_obj.msg_general.text = error.response.data.exceptions
                        }
                    }
                    if (!!error.response.data.fields_exceptions.email) {
                        vue_obj.msg_email.type = 'alert'
                        vue_obj.msg_email.text = error.response.data.fields_exceptions.email
                        vue_obj.msg_email.error = true
                    }
                    if (!!error.response.data.fields_exceptions.password) {
                        vue_obj.msg_password.type = 'alert'
                        vue_obj.msg_password.text = error.response.data.fields_exceptions.password
                        vue_obj.msg_password.error = true
                    }
                    if (!!error.response.data.fields_exceptions.password_confirmation) {
                        vue_obj.msg_password_confirmation.type = 'alert'
                        vue_obj.msg_password_confirmation.text = error.response.data.fields_exceptions.password_confirmation
                        vue_obj.msg_password_confirmation.error = true
                    }
                    if (!!error.response.data.fields_exceptions.name) {
                        vue_obj.msg_name.type = 'alert'
                        vue_obj.msg_name.text = error.response.data.fields_exceptions.name
                        vue_obj.msg_name.error = true
                    }
                    if (!!error.response.data.fields_exceptions.rules) {
                        vue_obj.msg_rules.type = 'alert'
                        vue_obj.msg_rules.text = error.response.data.fields_exceptions.rules
                        vue_obj.msg_rules.error = true
                    }
                })
        }
    },
    computed: {
        getRules() {
            return this.rules_text
        },
        isRegistrationForm() {
            return this.registrarion_form
        }
    },
}

function updateRules(vue_obj) {
    console.log('info')
    axios({
            method: 'GET',
            url: config.API_HOST + '/info/rules'
        })
        .then(function (response) {
            console.log(response)
            vue_obj.rules_text = '<div>' + response.data.text + '</div>'
        })
        .catch(function (error) {
            console.log(error)
        })
}
</script>



// WEBPACK FOOTER //
// src/components/registration.vue